import { render, staticRenderFns } from "./laser-resources-banner-widget.vue?vue&type=template&id=eec19406&"
import script from "./laser-resources-banner-widget.vue?vue&type=script&lang=ts&"
export * from "./laser-resources-banner-widget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports